<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedRateTypes"
      multi-select
      class="tw-w-full"
      :label="meta.filter.quickFilter ? '' : $t('Rate types')"
      :list="rateTypes"
      :max-labels-visible="meta.filter.quickFilter ? 1 : 10"
      :placeholder="$t('All rate types')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { RateType } from '@/gql/graphql'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedRateTypes: ModelRef<string[]> = defineModel({
  default: () => [],
})

const rateTypeLabels: Record<string, string> = {
  [RateType.Hourly]: $t('Hourly'),
  [RateType.Daily]: $t('Daily'),
  [RateType.Weekly]: $t('Weekly'),
  [RateType.Monthly]: $t('Monthly'),
  [RateType.Fixed]: $t('Fixed'),
  [RateType.Unknown]: $t('Unknown'),
}

const orderedRateTypes = [
  RateType.Hourly,
  RateType.Daily,
  RateType.Weekly,
  RateType.Monthly,
  RateType.Fixed,
  RateType.Unknown,
]

const rateTypes = computed(() =>
  orderedRateTypes.map((rateType) => ({
    label: rateTypeLabels[rateType] ?? rateType,
    value: rateType,
  })),
)
</script>
